import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { woodstockVtConfig } from "./data";

export default function WoodstockVtPage() {
  return <CityPageTemplate config={woodstockVtConfig} />;
}